import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  content: {
    flex: "1 1 auto",
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    backgroundColor: "var(--color-background)",
    boxSizing: "border-box",
  },
});
